import { render, staticRenderFns } from "./TrainRecord.vue?vue&type=template&id=711b2212&scoped=true&"
import script from "./TrainRecord.vue?vue&type=script&lang=js&"
export * from "./TrainRecord.vue?vue&type=script&lang=js&"
import style0 from "./TrainRecord.vue?vue&type=style&index=0&id=711b2212&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "711b2212",
  null
  
)

export default component.exports